import { render } from "./WaterQuality.vue?vue&type=template&id=1ebbb4ee&scoped=true"
import script from "./WaterQuality.vue?vue&type=script&lang=js"
export * from "./WaterQuality.vue?vue&type=script&lang=js"

import "./WaterQuality.vue?vue&type=style&index=0&id=1ebbb4ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebbb4ee"]])

export default __exports__